

export function SocialFrames() {
  const frames = [
    { label: "1:1", className: "aspect-square w-[31%]" },
    { label: "4:5", className: "aspect-[4/5] w-[31%]" },
    { label: "9:16", className: "aspect-[9/16] w-[25%]" },
  ];

  return (
    <div className="flex items-end gap-4 md:gap-5 w-full max-w-[440px]">
      {frames.map((frame, index) => (
        <div
          key={frame.label}
          className={`${frame.className} relative rounded-lg border border-line bg-surface-raised/60 overflow-hidden`}
          style={{
            animation: "service-drift 5.5s ease-in-out infinite",
            animationDelay: `${index * -1.4}s`,
          }}
        >
          <div className="absolute inset-x-3 top-3 h-1.5 rounded-full bg-brand/25" />
          <div className="absolute inset-x-3 top-6 h-1.5 w-2/3 rounded-full bg-brand/15" />
          <span className="absolute bottom-2 right-2.5 font-mono text-[10px] tracking-[0.15em] text-ink-subtle">
            {frame.label}
          </span>
        </div>
      ))}
    </div>
  );
}

export function ConsultingFlow({ steps }: { steps: string[] }) {
  return (
    <ol className="flex flex-col gap-0 w-full max-w-sm">
      {steps.map((step, index) => (
        <li key={step} className="flex gap-4">
          <div className="flex flex-col items-center">
            <span
              className="op-pulse block h-2.5 w-2.5 rounded-full bg-brand shrink-0"
              style={{ animationDelay: `${index * -0.6}s` }}
            />
            {index < steps.length - 1 && (
              <span className="w-px flex-1 bg-line" aria-hidden="true" />
            )}
          </div>

          <div className="pb-4 lg:pb-7 -mt-1">
            <span className="font-mono text-[11px] tracking-[0.18em] text-ink-subtle tabular-nums">
              {String(index + 1).padStart(2, "0")}
            </span>
            <p className="text-ink">{step}</p>
          </div>
        </li>
      ))}
    </ol>
  );
}

export function EmbeddedSeats({
  clientLabel,
  ours = 2,
  theirs = 6,
}: {
  clientLabel: string;
  ours?: number;
  theirs?: number;
}) {
  const seats = [
    ...Array.from({ length: theirs }, (_, i) => ({ id: `t${i}`, sdd: false })),
    ...Array.from({ length: ours }, (_, i) => ({ id: `o${i}`, sdd: true })),
  ];

  seats.sort((a, b) => a.id.localeCompare(b.id));

  return (
    <div className="flex flex-col gap-5 w-full max-w-sm">
      <div className="grid grid-cols-4 gap-3">
        {seats.map((seat, index) =>
          seat.sdd ? (
            <span
              key={seat.id}
              className="op-pulse aspect-square rounded-lg bg-brand"
              style={{ animationDelay: `${index * -0.5}s` }}
            />
          ) : (
            <span
              key={seat.id}
              className="aspect-square rounded-lg border border-line bg-surface-raised/40"
            />
          ),
        )}
      </div>

      <div className="flex items-center gap-5 font-mono text-[11px] tracking-[0.15em] uppercase text-ink-subtle">
        <span className="flex items-center gap-2">
          <span className="h-2.5 w-2.5 rounded-sm bg-brand" />
          SdD
        </span>
        <span className="flex items-center gap-2">
          <span className="h-2.5 w-2.5 rounded-sm border border-line" />
          <span>{clientLabel}</span>
        </span>
      </div>
    </div>
  );
}
